export const AVAILABILITY_POPOVER_AFTER_SEARCH_FROM_HOME_PAGE_TEST_NAME = 'availability_popover_after_search_from_home_page_test_name_com_742_2022_04_08';
export const AVAILABILITY_POPOVER_AFTER_SEARCH_FROM_HOME_PAGE_TEST_PERCENT = 0.5;
export const AVAILABILITY_POPOVER_AFTER_SEARCH_FROM_HOME_SEARCH_TILES_SOURCE = 'search_tiles';
export const AVAILABILITY_POPOVER_AFTER_SEARCH_FROM_HOME_HERO_TILES_SOURCE = 'home_hero';
export const LAST_SEARCH_DESKTOP_LOCATION = 'last_search_desktop_location';
